import { useContext } from 'react';
import type { EntitySecurityContextEntry } from '../../types';
import { EntitySecurityContext } from '../contexts/EntitySecurityContext';

export function useEntitySecurityChain(): EntitySecurityContextEntry[] {
    const contextValue = useContext(EntitySecurityContext);
    return contextValue?.entitySecurityContexts ?? [];
}
